module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/056-guinea-bissau-ee5d83a22a4ffebb0352ab72a3cd1236.svg";